import "./MindMappingReportAHeader.css";

export default function MindMappingReportAHeader({ toggle }) {
  return (
    <div className={toggle ? "header-adjust" : "mind-mapping-report-header-container"}>
      <div className="mind-mapping-report-header-card">
        <div className="mind-mapping-report-header-row">

          {/* LEFT COLUMN: Logo */}
          <div className="mind-mapping-report-header-left-col">
            <img
              className="mind-mapping-report-header-logo"
              src="/image/logo.png"
              alt="Marsmate Logo"
            />
          </div>

          {/* MIDDLE COLUMN: Title & Details */}
          <div className="mind-mapping-report-header-middle-col">
            <h1 className="mind-mapping-report-header-title">
              MARSMATE MIND MAPPING AUTOMATION ENGINE
            </h1>
            <div className="mind-mapping-report-header-details">
              <p>
                AI-driven visualization of skills, market gaps, sector focus,
                and execution-ready technologies
              </p>
            </div>
          </div>

          {/* RIGHT COLUMN: Report A+ Badge */}
          <div className="mind-mapping-report-header-right-col">
            <div className="rh-aplus-badge">
              <span className="rh-aplus-crown">♛</span>
              <span className="rh-aplus-label">Report A+</span>
              <span className="rh-aplus-tier">Premium</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}